<script type="text/javascript">
	import { onMount, createEventDispatcher } from "svelte"
	import { get, writable } from "svelte/store"

	import API from "../../API/API"
	import AdminStore from "./Store"

	import ROI from "../../Models/ROI"
	import RegionType from "../../Models/Enums/RegionType"

	import Form from './Form.svelte';
	import Button, {Label} from '@smui/button';
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Select, {Option} from '@smui/select';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import Icon from "@smui/textfield/icon/index";
	import SpinnerButton from "./SpinnerButton.svelte";

	import ValidationHelper from "../../Helpers/ValidationHelper";
	import { formatUnixTimestamp } from "../../Helpers/Misc/timeHelper";

	export let roi = null; // ROI Model

	const dispatch = createEventDispatcher(); // submit | reset | delete

	const Loading = {
		NONE: -1,
		SAVING_ROI: 0,
		PULLING_ROI_GEOJSON: 1,
		DELETING_ROI: 2
	};

	let createEditable = (roi) => {
		return {
			name: roi.name,
			region_type: roi.regionType,
			geojson: roi.geojson
		};
	};
	let editable = createEditable(roi);

	let form = null;
	let loading = writable(Loading.NONE);

	let style = "width:100%;margin-top:10px;";
	$: if (form) form.setReadOnly($loading != Loading.NONE);

	let companies = AdminStore.cms.companies;
	let roiTypes = RegionType.all();

	let onReset = () => {
		editable = createEditable(roi);
		console.log("init/reset editable", editable);
		dispatch('reset');
	}

	// let onSaveGeoJson = () => {
	// 	$loading = Loading.SAVING_ROI_GEOJSON;
	// 	API.put("admin/rois/" + roi.id + "/geojson", {
	// 			geojson: {}
	// 		}).then((response) =>{
	// 			console.log("response", response);
	// 			roi.setGeojson(response.geojson);
	// 			onReset();
	// 			dispatch('submit', {roi});
	// 			form.snackbar.start("ROI geojson saved successfully.", "success");
	// 		}).catch(()=>{
	// 			form.snackbar.start("ROI geojson save failed.", "error")
	// 		}).finally(() => {
	// 			$loading = Loading.NONE;
	// 		});
	// }
	let onPullGeoJSON = () => {
		$loading = Loading.PULLING_ROI_GEOJSON;
		API.get("admin/rois/" + roi.id)
			.then((response) =>{
				console.log("response", response);
				roi.setData(response);
				onReset();
				form.snackbar.start("ROI GeoJSON pulled successfully.", "success");
			}).catch(()=>{
				form.snackbar.start("ROI GeoJSON pull failed.", "error");
			}).finally(() =>{
				$loading = Loading.NONE;
			})
	}
	let onSubmit = () => {
		// Validate region type
		if (RegionType.all().indexOf(editable.region_type) == -1) {
			form.snackbar.start("Invalid Region Type.", "error");
			return;
		}

		// Validate geojson
		try {
			if (roi.hasGeoJSON()) {
				JSON.parse(editable.geojson);
			}
		}
		catch(e) {
			form.snackbar.start("Invalid GeoJSON.", "error");
			return;
		}

		let data = editable;
		if (!roi.hasGeoJSON()) {
			delete data.geojson;
		}
		if (roi.isNew() ) {
			data.geojson = "{}";
		}

		// We only want to send the info that has changed... I think...
		let n = roi.isNew();
		let url = n ? "admin/rois/create" : "admin/rois/" + roi.id;
		$loading = Loading.SAVING_ROI;
		API.put(url, data)
			.then((response) =>{
				console.log("response", response);
				if (roi.isNew()) {
					AdminStore.actions.addROI(roi);
				}
				roi.setData(response);
				roi = roi;
				onReset();
				form.snackbar.start("ROI " + (n ? "created" : "updated") + " successfully.", "success");
				dispatch('submit', {roi});
			}).catch(()=>{
				form.snackbar.start("ROI " + (n ? "creation" : "update") + " failed.", "error");
			}).finally(() =>{
				$loading = Loading.NONE;
			})
	};
	let onDelete = () => {
		AdminStore.cms.confirmDialog.onConfirm = () => {
			console.log('confirm');
			$loading = Loading.DELETING_ROI;
			API.delete("admin/rois/" + roi.id)
				.then((response)=>{
					console.log(response);
					form.snackbar.start("ROI deleted successfully.", "success");
					AdminStore.actions.deleteROI(roi);
					dispatch('delete');
				})
				.catch(()=>{
					form.snackbar.start("ROI deletion failed.", "error");
				})
				.finally(()=>{
					$loading = Loading.NONE;
					AdminStore.cms.confirmDialog.visible.set(false);
				});
		};
		AdminStore.cms.confirmDialog.visible.set(true);
		return;



	}

	onMount(()=>{
		onReset();
	});
</script>

<Form bind:this={form} id='admin-roi-form'>
	{#if roi.isNew()}
		<h2>New ROI</h2>
	{:else}
		<h2>Existing ROI</h2>
	{/if}

	<DataTable table$aria-label="ROI" style={style}>
		<Head style="display: none">
			<Row>
				<Cell></Cell>
				<Cell></Cell>
			</Row>
		</Head>
		<Body>
			<Row>
				<Cell>Name</Cell>
				<Cell>
					<Textfield dense variant="outlined" bind:value={editable.name} style="width:100%" />
				</Cell>
			</Row>
			<Row>
				<Cell>Region Type</Cell>
				<Cell>
					<select class='default' bind:value={editable.region_type} style="width:100%;">
						{#each roiTypes as rt}
							<option value={rt} selected={editable.region_type === rt}>{rt}</option>
						{/each}
					</select>
				</Cell>
			</Row>
			{#if !roi.isNew()}

				{#if roi.geojson.length > 0}
					<Row>
						<Cell>GeoJSON</Cell>
						<Cell>
							<!-- <Textfield dense variant="outlined" bind:value={editable.geojson} style="width:100%" /> -->
							<textarea class='long-textarea' bind:value={editable.geojson} style="min-height:150px;"/>
						</Cell>
					</Row>
				{:else}
					<Row>
						<Cell>GeoJSON</Cell>
						<Cell>
							{#if $loading == Loading.PULLING_ROI_GEOJSON}
								<SpinnerButton style={style+";margin-bottom:10px;"}/>
							{:else}
								<Button on:click={onPullGeoJSON} color="primary" class="bg-info" variant="unelevated" style={style+";margin-bottom:10px;"}><Label>Edit</Label></Button>
							{/if}
						</Cell>
					</Row>
				{/if}

				<!-- <Row>
					<Cell>Map</Cell>
					<Cell>
						<div style='border:1px solid #999;margin:10px;background-color:#ddf;width:calc(100% - 20px);height:200px;'>

						</div>
					</Cell>
				</Row>-->
				<Row>
					<Cell>Last Updated</Cell>
					<Cell>{formatUnixTimestamp(roi.lastUpdated)}</Cell>
				</Row>
			{/if}
		</Body>
	</DataTable>



	{#if $loading == Loading.SAVING_ROI}
		<SpinnerButton style={style}/>
	{:else}
		<Button on:click={onSubmit} color="primary" variant="unelevated" style={style}><Label>{((roi.isNew())?"Add ROI":"Update ROI")}</Label></Button>
	{/if}

	<Button on:click={onReset} color="primary" class="bg-info" variant="unelevated" style={style}><Label>Reset</Label></Button>

	{#if !roi.isNew()}
		<!-- <h2 style={style}>Actions</h2> -->
		<hr style={style}/>

		{#if $loading == Loading.DELETING_ROI || $loading == Loading.DISABLING_ROI}
			<SpinnerButton style={style}/>
		{:else}
			<Button color="secondary" variant="unelevated" class="bg-error" on:click={onDelete} style={style}><Label>Delete ROI</Label></Button>
		{/if}
	{/if}


</Form>
